export default __webpack_public_path__ + "static/humza-3b46f5f0a353ba8599566013271dcc1c.jpeg";